import { render } from "./SelectPrestation.vue?vue&type=template&id=25e69d61"
import script from "./SelectPrestation.vue?vue&type=script&lang=js"
export * from "./SelectPrestation.vue?vue&type=script&lang=js"

import "./SelectPrestation.vue?vue&type=style&index=0&id=25e69d61&lang=css"
script.render = render

export default script